export const SWITCH_ACTIVE_GAUGE = 'reports/productivity/SWITCH_ACTIVE_GAUGE'
